import type { MessageProps } from './types';

import { ModeratorMessage } from './moderator-message';
import { UserMessage } from './user-message';
import { getLocale } from '../../../i18n';
import { useSelectedLanguage } from '../../../viewer/providers/selected-language-provider';

export function Message(props: MessageProps) {
  const { selectedLanguage } = useSelectedLanguage();
  const locale = getLocale(selectedLanguage?.code);

  return props.message.sender.role === 'operator' ? (
    <ModeratorMessage locale={locale} {...props} />
  ) : (
    <UserMessage locale={locale} {...props} />
  );
}
